"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.experiencePageQuery = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.string.link");
const react_1 = __importDefault(require("react"));
const layouts_1 = __importDefault(require("../layouts"));
const SectionWork_1 = __importDefault(require("../components/experience/SectionWork"));
const SectionEducation_1 = __importDefault(require("../components/experience/SectionEducation"));
const SectionVolunteering_1 = __importDefault(require("../components/experience/SectionVolunteering"));
const helpers_1 = require("../utils/helpers");
exports.experiencePageQuery = "3168171430";
var ExperiencePage = function ExperiencePage(_ref) {
    var data = _ref.data;
    var enteries = {
        work: helpers_1.filterByFeatured(data.work.nodes.map(function (t) {
            return {
                title: t.data.title,
                featured: !!t.data.featured,
                from: t.data.from,
                to: t.data.to,
                link: t.data.link,
                notes: t.data.notes ? t.data.notes.childMarkdownRemark.html : null,
                roles: t.data.roles ? t.data.roles.map(function (r) {
                    return r.data.title;
                }) : [],
                location: (t.data.location ? t.data.location.map(function (l) {
                    return l.data.title;
                }) : [])[0],
                organisation: (t.data.organisation ? t.data.organisation.map(function (o) {
                    return o.data.title;
                }) : [])[0],
                tags: t.data.tags ? t.data.tags.map(function (t) {
                    return t.data.name;
                }) : null
            };
        })),
        education: helpers_1.filterByFeatured(data.education.nodes.map(function (t) {
            return {
                title: t.data.title,
                featured: !!t.data.featured,
                from: t.data.from,
                to: t.data.to,
                link: t.data.link,
                notes: t.data.notes ? t.data.notes.childMarkdownRemark.html : null,
                organisation: (t.data.organisation ? t.data.organisation.map(function (o) {
                    return o.data.title;
                }) : [])[0],
                tags: t.data.tags ? t.data.tags.map(function (t) {
                    return t.data.name;
                }) : null
            };
        })),
        volunteering: helpers_1.filterByFeatured(data.volunteering.nodes.map(function (t) {
            return {
                title: t.data.title,
                featured: !!t.data.featured,
                from: t.data.from,
                link: t.data.link,
                notes: t.data.notes ? t.data.notes.childMarkdownRemark.html : null,
                organisation: (t.data.organisation ? t.data.organisation.map(function (o) {
                    return o.data.title;
                }) : [])[0],
                tags: t.data.tags ? t.data.tags.map(function (t) {
                    return t.data.name;
                }) : null
            };
        }))
    };
    return /*#__PURE__*/ react_1.default.createElement(layouts_1.default, null, /*#__PURE__*/ react_1.default.createElement("div", {
        className: "row"
    }, /*#__PURE__*/ react_1.default.createElement("section", null, /*#__PURE__*/ react_1.default.createElement("h1", null, "Experience"), /*#__PURE__*/ react_1.default.createElement("div", {
        className: "container--small"
    }, /*#__PURE__*/ react_1.default.createElement(SectionWork_1.default, {
        work: enteries.work
    }), /*#__PURE__*/ react_1.default.createElement(SectionEducation_1.default, {
        education: enteries.education
    }), /*#__PURE__*/ react_1.default.createElement(SectionVolunteering_1.default, {
        volunteering: enteries.volunteering
    })))));
};
exports.default = ExperiencePage;
